import { RpcEndpoint } from '@drift/common';
import Env, {
	syncGetCurrentSettings,
} from '../../environmentVariables/EnvironmentVariables';
import { _GetRpcToUse } from './rpcUtils_logic';

/**
 * Util function to fetch the current RPC to use based on current environment and user settings
 * @returns
 */
export const getRpcToUse = (): RpcEndpoint => {
	const currentSettings = syncGetCurrentSettings();

	return _GetRpcToUse(
		currentSettings?.devnetOverride ?? false,
		Env.sdkEnv,
		currentSettings?.rpcEndpoint ?? { label: '', value: '' }
	);
};
